<template>
  <mf-tooltip v-if="tooltip" max-width="300" bottom variant="secondary">
    <template #activator="{ on }">
      <span class="cursor-pointer" @click="toggleQuickActionGroup">
        <mf-icon :fill="isIncluded" :disabled="disabled" :color="iconColor" :large="iconLarge"> bolt </mf-icon>
      </span>
    </template>
    {{ tooltip }}
  </mf-tooltip>
  <span v-else class="cursor-pointer" @click="toggleQuickActionGroup">
    <mf-icon :fill="isIncluded" :disabled="disabled" :color="iconColor" :large="iconLarge"> bolt </mf-icon>
  </span>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    shortDescription: {
      type: [String, Function],
      required: true,
    },
    longDescription: {
      type: [String, Function],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    quickActionGroupId: {
      type: String,
      required: true,
    },
    quickActionGroup: {
      type: String,
    },
    quickActionGroupValue: {
      type: [Object, Array, Number, String],
    },
    segmentationGroup: {
      type: [Object, Function],
      required: true,
    },
    iconColor: {
      type: String,
      required: false,
    },
    iconLarge: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isIncluded: false,
  }),
  computed: {
    ...mapState({
      isSelectingQuickActionGroups: (state) => state.isSelectingQuickActionGroups,
      quickActionGroups: (state) => state.quickActionGroups,
    }),
  },
  watch: {
    isSelectingQuickActionGroups(value) {
      if (!value) {
        this.isIncluded = false
      }
    },
    quickActionGroupId(value) {
      const currentQuickActionExistInGroups = this.quickActionGroups.some((group) => group.id === value)
      this.isIncluded = currentQuickActionExistInGroups
    },
  },
  methods: {
    ...mapActions(['includeQuickActionGroup', 'removeQuickActionGroup']),
    refetch() {
      if (!this.isIncluded) return
      this.removeSelfQuickActionGroup()
      this.addSelfQuickActionGroup()
    },
    removeSelfQuickActionGroup() {
      this.removeQuickActionGroup(this.quickActionGroupId)
    },
    addSelfQuickActionGroup() {
      this.includeQuickActionGroup({
        id: this.quickActionGroupId,
        group: this.quickActionGroup,
        shortDescription: this.shortDescription,
        longDescription: this.longDescription,
        groupValue: this.quickActionGroupValue,
        segmentationGroup: this.segmentationGroup,
        tooltip: this.tooltip,
      })
    },
    toggleQuickActionGroup() {
      if (this.isIncluded) {
        this.removeSelfQuickActionGroup()
        this.isIncluded = false
      } else {
        this.addSelfQuickActionGroup()
        this.isIncluded = true
      }
    },
  },
}
</script>
